// extracted by mini-css-extract-plugin
module.exports = {"lds-hourglass":"style_lds-hourglass__2g0AP","lds-hourglass-after":"style_lds-hourglass-after__2qY4w"};